import { Link } from "react-router-dom";
import { CONTACT_EMAIL, openCookieSettings } from "@/lib/legal";

export const SiteFooter = () => (
  <footer className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-6 text-xs text-muted-foreground" data-testid="site-footer">
    <span>© {new Date().getFullYear()} easysweetchat.com</span>
    <Link to="/aszf" className="hover:text-white" data-testid="footer-terms-link">ÁSZF</Link>
    <Link to="/adatvedelem" className="hover:text-white" data-testid="footer-privacy-link">Adatkezelési tájékoztató</Link>
    <button onClick={openCookieSettings} className="hover:text-white" data-testid="footer-cookie-settings">Süti beállítások</button>
    <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-white" data-testid="footer-contact-link">Bejelentés / kapcsolat: {CONTACT_EMAIL}</a>
  </footer>
);
